import React, { useState } from "react";
import Footer from "../components/Footer";
import DonorNav from "./DonorNav";
import ReactLoading from "react-loading";

const UserViewAnnouncement = () => {
  const [IsLoading, setIsLoading] = useState(false);
  const Loader = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  return (
    <>
      {IsLoading ? (
        <div className="loader">
          <ReactLoading
            className="spinner"
            type="spokes"
            color="#d9534f"
            height={100}
            width={50}
          />
          <DonorNav />
        </div>
      ) : (
        <>
          <DonorNav />
          <div id="wrapper" onClick={Loader}>
            <div id="page-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <div className=".col-lg-12">
                    <h1 className="page-header">Announcement Detail</h1>
                  </div>
                </div>

                <div className="row">
                  <div className=".col-lg-12">
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        Total Records of announcement made
                      </div>

                      <div className="panel-body">
                        <div className="table-responsive">
                          <table
                            className="table table-striped table-bordered table-hover"
                            id="dataTables-example"
                          >
                            <thead>
                              <tr>
                                <th>Title</th>
                                <th>Blood Needed</th>
                                <th>Announcement Date</th>
                                <th>Organizer</th>
                                <th>Requirements</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>".$row['announcement']."</td>
                                <td>".$row['bloodneed']."</td>
                                <td>".$row['dat']."</td>
                                <td>".$row['organizer']."</td>
                                <td>".$row['requirements']."</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {/* <Footer /> */}
    </>
  );
};

export default UserViewAnnouncement;
